import { useState,useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/login/LoginForm.jsx";
import Dashboard from "./Dashboard.jsx";
import { LoaderProvider } from "./context/LoaderContext.jsx";
import LoaderOverlay from "./widgets/loader/LoaderOverlay.jsx";
import Changepassword from './components/changepassword/Changepassword.jsx';
import AdminDashboard from './admin/dashboard/Dashboard.jsx'
import Resetpassword from "./components/changepassword/Resetpassword.jsx";
import { host, adminhost } from "./constants/backendpath";


function AppContent() {
  // const [isAllowed, setIsAllowed] = useState(false);
  // const [response, setResponse] = useState('')
  // useEffect(() => {
  //   const restrict = async () => {
  //     const response = await axios.post(`${host}check-ip`)
  //     if (response.status === 200) {
  //       setIsAllowed(true)
  //       setResponse(response.data.ip);
  //     }
  //     else {
  //       setIsAllowed(false)
  //       setResponse(response.data.ip);
  //     }
  //   }
  //   restrict();
  // }, []);

  // if (!isAllowed) {
  //   return (
  //     null
  //   );
  // }

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Login admin={false} />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/resetPassword' element={<Resetpassword />} />
        <Route path='/changePassword' element={<Changepassword />} />
        <Route path='/admin/login' element={<Login admin={true} />} />
        <Route path='/admin/dashboard' element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}
function App() {
  return (
    <LoaderProvider>
      <AppContent />
      <LoaderOverlay />
    </LoaderProvider>
  );
}
export default App;
